import React, { Component } from 'react';
import classNames from 'classnames';
import { array, arrayOf, bool, func, object, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { findOptionsForSelectFilter } from '../../util/search';
import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_PUBLISHED,
  propTypes,
  isStartup,
  isClientType,
  isProviderType,
  getUserSubscriptionLevel,
  SUBSCRIPTION_LEVEL_2,
} from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { timestampToDate, calculateQuantityFromHours } from '../../util/dates';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  Modal,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Button,
  IconFire,
  PrimaryButton, DraftContent,
} from '../../components';
import { EnquiryForm } from '../../forms';
import { TopbarContainer, NotFoundPage } from '../../containers';

import {
  sendEnquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
  loadData
} from './ListingPage.duck';
import SectionImages from './SectionImages';
import SectionAvatar from './SectionAvatar';
import SectionHeading from './SectionHeading';
import SectionDescriptionMaybe from './SectionDescriptionMaybe';
import SectionShortDescriptionMaybe from './SectionShortDescriptionMaybe';
import SectionReviews from './SectionReviews';
import SectionTotalReviews from './SectionTotalReviews';
import OtherInfoSection from './OtherInfoSection/OtherInfoSection';
import PostsSection from './PostsSection/PostsSection';
import YoutubeSection from './YoutubeSection/YoutubeSection';
import FilesSection from './FilesSection/FilesSection';
import { HashLink as Link } from 'react-router-hash-link';
import { requestUpdateListing } from '../EditListingPage/EditListingPage.duck';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      isRequestForQuote: false,
      completePopupOpen: false,
      completePopupType: null,
      startupOfferPopupOpen: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
    this.onHandleCompletePopup = this.onHandleCompletePopup.bind(this);
    this.onHandleStartupOffer = this.onHandleStartupOffer.bind(this);
  }

  handleSubmit(values) {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);

    const { bookingStartTime, bookingEndTime, ...restOfValues } = values;
    const bookingStart = timestampToDate(bookingStartTime);
    const bookingEnd = timestampToDate(bookingEndTime);

    const bookingData = {
      quantity: calculateQuantityFromHours(bookingStart, bookingEnd),
      ...restOfValues,
    };

    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart,
        bookingEnd,
      },
      confirmPaymentError: null,
    };

    const saveToSessionStorage = !this.props.currentUser;

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);

    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);

    // Clear previous Stripe errors from store if there is any
    onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routes,
        { id: listing.id.uuid, slug: createSlug(listing.attributes.title) },
        {}
      )
    );
  }

  onContactUser(data) {
    const { currentUser, history, callSetInitialValues, params, location } = this.props;
    const isRequestForQuote = data?.isRequestForQuote;
    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ isRequestForQuote: isRequestForQuote });
      this.setState({ enquiryModalOpen: true });
    }
  }

  onSubmitEnquiry(values) {
    const { history, params, onSendEnquiry, getOwnListing, getListing } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const { message } = values;
    const enquiryValues = { ...values };

    const isPendingApprovalVariant = params.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = params.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const probiderId = currentListing?.author?.id?.uuid;

    onSendEnquiry(listingId, probiderId, enquiryValues)
      .then(txId => {
        this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }

  onHandleCompletePopup(status, type) {
    this.setState({ completePopupOpen: status });
    this.setState({ completePopupType: type });
  }

  onHandleStartupOffer(status) {
    this.setState({ startupOfferPopupOpen: status })
  }

  render() {
    const {
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      fetchReviewsError,
      sendEnquiryInProgress,
      sendEnquiryError,
      filterConfig,
      currentUserListing,
      onUpdateListing,
      onLoadData,
      authorBackgroundImg,
    } = this.props;
    let reviews = this.props.reviews;

    const listingId = new UUID(rawParams.id);
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };
    const isOffer = !!currentListing?.attributes?.publicData?.isOffer;
    const isStartupOffer = !!currentListing?.attributes?.publicData?.startupOfferTitle;

    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;

    const listingTab = isOffer ? 'offer' : isDraftVariant ? 'photos' : 'description';

    const isApproved =
      // currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;
      currentListing.id && currentListing.attributes.state === LISTING_STATE_PUBLISHED;


    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;


    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
    } = currentListing.attributes;

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const bookingTitle = (
      <FormattedMessage id="ListingPage.bookingTitle" values={{ title: richTitle }} />
    );

    const topbar = <TopbarContainer />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
      } else {
        this.handleSubmit(values);
      }
    };

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title: publicData?.customDisplayName || title, price: formattedPrice, siteTitle }
    );

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const yogaStylesOptions = findOptionsForSelectFilter('yogaStyles', filterConfig);
    const certificateOptions = findOptionsForSelectFilter('certificate', filterConfig);

    const subscriptions = currentUser?.attributes?.profile?.privateData?.subscriptions || [];
    const hasAnySubscriptions = subscriptions.length > 0;
    const isProviderListing = publicData?.listingType === 'provider';
    const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'service-provider';
    const isCustomer = currentUser?.attributes?.profile?.publicData?.userType === 'client';

    const dedicatedReviews = publicData?.dedicatedReviews || [];
    reviews = [...reviews, ...dedicatedReviews];

    const customDisplayName = publicData?.customDisplayName;

    const currentUserListingId = currentUserListing?.[0]?.id?.uuid
    const currentUserListingSlug = !!currentUserListing?.length && createSlug(currentUserListing?.[0]?.attributes?.title)

    const offerDescription = publicData?.offerDescription;

    const currentUserCompletedProfile = currentUser?.attributes?.profile?.publicData?.profileCompleted;

    const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);
    const subscriptionLevelToLow = userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;
    const isClient = isClientType(currentUser);

    const isProviderVerified = publicData?.providerVerified;
    const isProviderStartup = isStartup(currentUser);


    const subscriptionLevel = publicData?.subscriptionLevel;
    const isStartupProvider = isStartup(currentUser);

    const providerType = publicData?.providerType;
    const isFreeListing = subscriptionLevel < SUBSCRIPTION_LEVEL_2;

    const isFreeClient = currentUser && isCustomer && userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;
    const isFreeStartup = currentUser && isStartupProvider && userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;
    const isFreeEstablishedCompany = currentUser && isProvider && userSubscriptionLevel < SUBSCRIPTION_LEVEL_2;

    const startupCondition = isFreeStartup && isFreeListing && providerType !== "startup";
    const establishedCompanyCondition = isFreeEstablishedCompany && isFreeListing && providerType !== "startup";

    const disableListing = isClient
      ? false
      : isProvider
        ? (startupCondition || establishedCompanyCondition)
        : null;;

    // if (disableListing && !isOwnListing) {
    //   return (
    //     <Page
    //       title={schemaTitle}
    //       scrollingDisabled={scrollingDisabled}
    //       author={authorDisplayName}
    //       contentType="website"
    //       description={null}
    //       facebookImages={facebookImages}
    //       twitterImages={twitterImages}
    //       schema={{
    //         '@context': 'http://schema.org',
    //         '@type': 'ItemPage',
    //         description: null,
    //         name: schemaTitle,
    //         image: schemaImages,
    //       }}
    //     >
    //       <LayoutSingleColumn className={css.pageRoot}>
    //         <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
    //         <LayoutWrapperMain>

    //           <div className={css.subscriptionLevelInfo}>
    //             <h2 className={css.subscriptionLevelInfoTitle}>
    //               <FormattedMessage id="ListingPage.subscriptionLevelToLow" />
    //             </h2>
    //           </div>
    //         </LayoutWrapperMain>
    //         <LayoutWrapperFooter>
    //           <Footer />
    //         </LayoutWrapperFooter>
    //       </LayoutSingleColumn>
    //     </Page>
    //   )
    // } else {
    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        contentType="website"
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: description,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        <LayoutSingleColumn className={css.pageRoot}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div>
              <SectionImages
                title={title}
                listing={currentListing}
                isOwnListing={isOwnListing}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingType,
                  tab: listingTab,
                }}
                imageCarouselOpen={this.state.imageCarouselOpen}
                onImageCarouselClose={() => this.setState({ imageCarouselOpen: false })}
                handleViewPhotosClick={handleViewPhotosClick}
                onManageDisableScrolling={onManageDisableScrolling}
                isOffer={isOffer}
                authorBackgroundImg={authorBackgroundImg}
              />
              <div className={css.contentContainer}>
                <SectionAvatar
                  listing={currentListing}
                  user={currentAuthor}
                  params={params}
                  isOffer={isOffer}
                />
                <div className={css.mainContent}>
                  <SectionHeading
                    priceTitle={priceTitle}
                    formattedPrice={formattedPrice}
                    richTitle={richTitle}
                    listingCertificate={publicData ? publicData.certificate : null}
                    certificateOptions={certificateOptions}
                    hostLink={hostLink}
                    showContactUser={showContactUser}
                    onContactUser={this.onContactUser}
                    currentListing={currentListing}
                    publicData={publicData}
                    isOffer={isOffer}
                    currentUser={currentUser}
                    isOwnListing={isOwnListing}
                    isProviderVerified={isProviderVerified}
                    sectionTotalReviews={
                      <SectionTotalReviews
                        currentUser={currentUser}
                        subscriptionLevelToLow={subscriptionLevelToLow}
                        publicData={publicData}
                      />
                    }
                  />
                  <SectionShortDescriptionMaybe publicData={publicData} isOffer={isOffer} />
                  <SectionDescriptionMaybe
                    description={description}
                    offerDescription={offerDescription}
                    isOffer={isOffer}
                  />
                  {!isOffer && (
                    <OtherInfoSection
                      listing={currentListing}
                      publicData={publicData}
                      intl={intl}
                      isProviderListing={isProviderListing}
                      subscriptionLevelToLow={subscriptionLevelToLow}
                      isOwnListing={isOwnListing}
                    />
                  )}

                  {(!subscriptionLevelToLow || isOwnListing) && (
                    <FilesSection
                      key='Documents'
                      files={publicData.files?.filter(f => !!f)}
                      label='Documents'
                      labelClassName={css.filesTitle}
                      showAsSwiper
                    />
                  )}

                  <PostsSection
                    listing={currentListing}
                    isOwnListing={isOwnListing}
                    publicData={publicData}
                    onManageDisableScrolling={onManageDisableScrolling}
                    onUpdateListing={onUpdateListing}
                    onLoadData={onLoadData}
                    id={listingId.uuid}
                    slug={listingSlug}
                  />

                  {(!subscriptionLevelToLow || isOwnListing) && (
                    <YoutubeSection
                      publicData={publicData}
                      listing={currentListing}
                      isOwnListing={isOwnListing}
                      onManageDisableScrolling={onManageDisableScrolling}
                      onUpdateListing={onUpdateListing}
                      onLoadData={onLoadData}
                      id={listingId.uuid}
                      slug={listingSlug}
                      intl={intl}
                    />
                  )}

                  {!isOffer &&
                    <SectionReviews
                      reviews={reviews}
                      fetchReviewsError={fetchReviewsError}
                      currentUser={currentUser}
                      subscriptionLevelToLow={subscriptionLevelToLow}
                      isOwnListing={isOwnListing}
                      publicData={publicData}
                      isOffer={isOffer}
                      isProvider={isProvider}
                    />
                  }
                </div>

                <div className={css.bookingPanel}>

                  {!isOffer && (
                    <>
                      {!isOwnListing && !currentUserCompletedProfile && !currentUserListing?.length ? (
                        <>
                          {isProvider && (
                            <div
                              className={css.actionButton}
                              onClick={() => this.onHandleCompletePopup(true, "newFlow")}
                            >
                              <FormattedMessage id="ListingPage.contact" />
                            </div>
                          )}
                          {!!currentUser && (
                            <div
                              className={css.actionButton}
                              onClick={() => this.onHandleCompletePopup(true, "newFlow")}
                            >
                              <FormattedMessage id="ListingPage.requestForQuote" />
                            </div>
                          )}
                        </>
                      ) : !isOwnListing && !currentUserCompletedProfile && currentUserListing?.length ? (
                        <>
                          {isProvider && (
                            <div
                              className={css.actionButton}
                              onClick={() => this.onHandleCompletePopup(true, "editFlow")}
                            >
                              <FormattedMessage id="ListingPage.contact" />
                            </div>
                          )}
                          <div
                            className={css.actionButton}
                            onClick={() => this.onHandleCompletePopup(true, "editFlow")}
                          >
                            <FormattedMessage id="ListingPage.requestForQuote" />
                          </div>
                        </>
                      ) : !isOwnListing ? (
                        <>
                          {isProvider && (
                            <Button className={css.actionButton} onClick={this.onContactUser}>
                              <FormattedMessage id="ListingPage.contact" />
                            </Button>
                          )}

                          {isProviderListing && (
                            <Button
                              className={css.actionButton}
                              onClick={() => this.onContactUser({ isRequestForQuote: true })}
                            >
                              <FormattedMessage id="ListingPage.requestForQuote" />
                            </Button>
                          )}
                        </>
                      ) : (
                        <>

                          {isProviderListing && (
                            <NamedLink
                              className={css.actionButton}
                              name="EditListingPage"
                              params={{ id: listingId.uuid, slug: listingSlug, type: LISTING_PAGE_PARAM_TYPE_EDIT, tab: 'posts' }}
                            >
                              <FormattedMessage id="ListingPage.addNews" />
                            </NamedLink>
                          )}
                          <Link
                            className={css.actionButton}
                            to={`${currentListing?.id?.uuid}/edit/photos`}
                          >
                            <FormattedMessage id="ListingPage.companyDocuments" />
                          </Link>
                        </>
                      )}
                    </>
                  )}

                  {isOffer && !isOwnListing ? <Button
                    className={css.actionButton}
                    onClick={() => handleBookingSubmit({})}
                  >
                    Checkout
                  </Button> : null}

                  {isProviderListing && isOwnListing && (
                    <NamedLink
                      className={css.actionButton}
                      name="CollectReviewPage"
                    >
                      {publicData.providerType === 'startup' ?
                        <FormattedMessage id="ListingPage.votes" /> :
                        <FormattedMessage id="ListingPage.reviews" />
                      }
                    </NamedLink>
                  )}

                  {isProviderListing && !isOwnListing && <>
                    {!currentUser ? <Button
                      className={css.actionButton}
                      onClick={() => this.onContactUser({ isRequestForQuote: true })}
                    >
                      <FormattedMessage id="ListingPage.requestForQuote" />
                    </Button> : null}
                    <NamedLink
                      className={classNames(css.actionButton, css.actionButtonDark)}
                      name="DedicatedReviewPage"
                      params={{ id: listingId.uuid }}
                    >
                      {publicData.providerType === 'startup' ?
                        <FormattedMessage id="ListingPage.leaveVotes" /> :
                        <FormattedMessage id="ListingPage.leaveAReview" />
                      }
                    </NamedLink>
                  </>}
                  {isStartupOffer && (
                    <div
                      className={classNames(css.actionButton, css.actionButtonDark)}
                      onClick={() => this.onHandleStartupOffer(true)}
                    >
                      <FormattedMessage id="ListingPage.offerButton" />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Modal
              id="ListingPage.enquiry"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.enquiryModalOpen}
              onClose={() => this.setState({ enquiryModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <EnquiryForm
                className={css.enquiryForm}
                submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
                listingTitle={customDisplayName || title}
                authorDisplayName={authorDisplayName}
                sendEnquiryError={sendEnquiryError}
                onSubmit={this.onSubmitEnquiry}
                inProgress={sendEnquiryInProgress}
                currentListing={currentListing}
                isRequestForQuote={this.state.isRequestForQuote}
              />
            </Modal>

            <Modal
              id="ListingPage.completePopup"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.completePopupOpen}
              onClose={() => this.onHandleCompletePopup(false, null)}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              {this.state.completePopupType === "editFlow" ? (
                <div className={css.actionPopup}>
                  <h2 className={css.actionTitle}>
                    <FormattedMessage id="ListingPage.completeProfileDescription" />
                  </h2>
                  <NamedLink
                    className={css.actionButton}
                    name="EditListingPage"
                    params={{ id: currentUserListingId, slug: currentUserListingSlug, type: LISTING_PAGE_PARAM_TYPE_EDIT, tab: 'photos' }}
                  >
                    <FormattedMessage id="ListingPage.completeProfileBtn" />
                  </NamedLink>
                </div>
              ) : (
                <div className={css.actionPopup}>
                  <h2 className={css.actionTitle}>
                    <FormattedMessage id="ListingPage.completeProfileDescription" />
                  </h2>
                  <NamedLink
                    className={css.actionButton}
                    name="NewListingPage"
                  >
                    <FormattedMessage id="ListingPage.completeProfileBtn" />
                  </NamedLink>
                </div>
              )}
            </Modal>
            <Modal
              id="ListingPage.startupOfferPopup"
              contentClassName={css.enquiryModalContent}
              isOpen={this.state.startupOfferPopupOpen}
              onClose={() => this.onHandleStartupOffer(false)}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.actionPopup}>
                <IconFire className={css.offerIcon} />
                <h2 className={css.offerHeading}>
                  <FormattedMessage id="ListingPage.offerTitle" />
                </h2>
                <p className={css.offerDisclaimer}>
                  <FormattedMessage id="ListingPage.offerDisclaimer" />
                </p>
                <p className={css.offerInfo}>
                  <FormattedMessage
                    id="ListingPage.offerValue"
                    values={{ name: <span>{currentListing?.attributes?.publicData?.startupOfferTitle}</span> }}
                  />
                </p>
                <p className={css.offerInfo}>
                  <FormattedMessage
                    id="ListingPage.offerReward"
                    values={{ reward: <span>{currentListing?.attributes?.publicData?.startupReward}</span> }}
                  />
                </p>
                <p>
                  <b><FormattedMessage id="ListingPage.offerDescription" /></b>
                  <DraftContent draftContent={currentListing?.attributes?.publicData?.startupOfferDescription} />
                </p>
                <p>
                  <FormattedMessage
                    id="ListingPage.offerPopupInfo"
                    values={{
                      contactLink: (
                        <span
                          className={css.offerDisclaimerButton}
                          onClick={() => {
                            this.onHandleStartupOffer(false);
                            this.onContactUser();
                          }}
                        >
                          <FormattedMessage id="ListingPage.contactLinkText" />
                        </span>
                      ),
                    }}
                  />
                </p>
                <PrimaryButton
                  className={css.offerButton}
                  type="button"
                  onClick={() => {
                    this.onHandleStartupOffer(false);
                    this.onContactUser();
                  }}
                >
                  <FormattedMessage id="ListingPage.contactLinkText" />
                </PrimaryButton>
              </div>
            </Modal>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}
// }

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendEnquiryError: null,
  filterConfig: config.custom.filters,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendEnquiryInProgress,
    sendEnquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
    currentUserListing,
    authorBackgroundImg,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const userListing = currentUserListing.filter(l => !l.attributes.publicData.isOffer);

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    currentUserListing: userListing,
    authorBackgroundImg,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
    dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
  onSendEnquiry: (listingId, probiderId, enquiryValues) => dispatch(sendEnquiry(listingId, probiderId, enquiryValues)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onUpdateListing: (tab, values) => dispatch(requestUpdateListing(tab, values)),
  onLoadData: (params, search) => dispatch(loadData(params, search)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageComponent);

export default ListingPage;
